/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/* jquery */
//import $ from 'jquery';
//window.$ = window.jQuery = $;
//require('./magnific-popup/dist/jquery.magnific-popup');

window.Vue = require('vue');

import VCalendar from 'v-calendar';
// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
    componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

// Moment
import moment from 'moment';
//import 'moment/locale/de';
//moment.lang("de");

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY')
    }
});
Vue.filter('formatTimeSlot', function (value) {
    if (value) {
        return moment(String(value)).format('HH:mm')
    }
});
Vue.filter('formatDateTime', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY HH:mm') + ' Uhr'
    }
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//import FullCalendar from '@fullcalendar/vue';
//import dayGridPlugin from '@fullcalendar/daygrid';
//import interactionPlugin from '@fullcalendar/interaction'

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('stores', require('./components/Stores.vue').default);
Vue.component('services', require('./components/Services.vue').default);
//Vue.component('calendar-component', require('./components/CalendarComponent.vue').default);
Vue.component('calendar-slots', require('./components/CalendarSlots.vue').default);
//Vue.component('calendar-slots-timeline', require('./components/CalendarSlotsTimeline.vue').default);
Vue.component('calendar-slots-timegrid', require('./components/CalendarSlotsTimegrid.vue').default);
Vue.component('calendar-list', require('./components/CalendarList.vue').default);


Vue.component('store-address', require('./components/StoreAddress.vue').default);
Vue.component('store-opening-times', require('./components/StoreOpeningTimes.vue').default);
Vue.component('store-logo', require('./components/StoreLogo.vue').default);

//Vue.component('studio-booking', require('./components/StudioBooking.vue').default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app'
});
